import {
  BallerzToken,
  BallerzUsers,
  BallerzChangeUser,
  BallerzRedirect,
  BallerzUserID,
} from "../../Client/Ballerz.js";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderFatherSon from "../../Components/HeaderFatherSon";

export default function SelectUser() {
  let ballerzToken = BallerzToken();
  let ballerzUsers = BallerzUsers();
  let ballerzUserID = BallerzUserID();

  const navigate = useNavigate();

  const location = useLocation();

  if (!ballerzToken) {
    BallerzRedirect();
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderFatherSon />

      <div className="flex flex-1">
        <main className="flex-1 p-4 sm:p-6">
          <div className="Kallisto_Bold text-2xl text-center my-6">
            Multiple players found for this email address. Please select a
            player to continue.
          </div>
          <div>
            {ballerzUsers?.map((user) => (
              <div
                onClick={() => {
                  BallerzChangeUser(user.ballerzUserID);
                  localStorage.setItem("ballerz-display-user", user.username);

                  navigate(`/`);
                }}
                className="
                          w-full
                          sm:w-[50%]
                          mx-auto
                          flex flex-col
                          items-center
                          sm:flex-row sm:items-center sm:justify-between
                          bg-[#1f2644] hover:bg-[#2c365f]
                          rounded-lg p-3 mt-3
                          text-white font-kallisto
                          gap-3 cursor-pointer
                        "
              >
                <div
                  className={`w-full sm:w-auto sm:min-w-[30%] ${
                    user.ballerzUserID !== ballerzUserID
                      ? "bg-[#0d1121]"
                      : "bg-[#90DEB6]"
                  } p-2 rounded flex justify-center items-center`}
                >
                  <span className="text-xl sm:text-2xl font-bold uppercase">
                    {user.username}
                  </span>
                </div>

                <div className="sm:flex-1 px-2 sm:ml-2 sm:mr-40 text-center sm:text-left">
                  <span className="text-xl sm:text-2xl Kallisto_Bold block truncate">
                    {user.firstname} {user.lastname}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
